import React, { useState, useEffect, useRef, useCallback } from "react";
import LoadingWell from "../../components/Loading/LoadingWell";
import { useLoading } from "../../context/LoadingContext";
import "./Search.css";
import Navbar from "../../components/Navbar/Navbar";
import GoogleAd from "../../components/GoogleAd/GoogleAd";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import {Link} from "react-router-dom";




export default function Search() {

  const [postTypes, setPostTypes] = useState([]);
  const [popularPosts, setPopularPosts] = useState([]);
  const [latestPosts, setLatestPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [popularLabels, setPopularLabels] = useState([]);

  const [query, setQuery] = useState("");
  const [author, setAuthor] = useState("");
  const [rovat, setRovat] = useState("");
  const [tag, setTag] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [results, setResults] = useState([]);
  const [noResult, setNoResult] = useState(false);
  const { loading, setLoading } = useLoading();
  const [initialLoading, setInitialLoading] = useState(true);
  const [showTagSuggestions, setShowTagSuggestions] = useState(false);
  const [showAuthorSuggestions, setShowAuthorSuggestions] = useState(false);
  const [authorSuggestions, setAuthorSuggestions] = useState([]);
  const tagInputRef = useRef(null);
  const authorInputRef = useRef(null);
  const pendingAutoSearchRef = useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const qParam = params.get('q');
    const tagParam = params.get('tag');
    if (tagParam) setTag(tagParam);
    if (qParam) {
      setQuery(qParam);
      // Mark that we should auto-search once query state reflects qParam
      pendingAutoSearchRef.current = qParam;
    }
  }, []);

  useEffect(() => {
    function handleMobileSearchOpen(e) {
      const input = document.querySelector('.search-form input[type="text"]');
      if (input) {
        input.focus();
      }
    }
    window.addEventListener('mobileSearchOpen', handleMobileSearchOpen);
    return () => {
      window.removeEventListener('mobileSearchOpen', handleMobileSearchOpen);
    };
  }, []);
  
  // Fetch author suggestions with debounce when author input changes
  useEffect(() => {
    if (!author || author.length === 0) {
      setAuthorSuggestions([]);
      return;
    }
    const t = setTimeout(() => {
      fetch(`${apiUrl}/author_suggestions?q=${encodeURIComponent(author)}`)
        .then(res => res.json())
        .then(data => setAuthorSuggestions(data))
        .catch(() => setAuthorSuggestions([]));
    }, 350);
    return () => clearTimeout(t);
  }, [author, apiUrl]);

  useEffect(() => {
      document.title = "Kútonline - Keresés";
    }, []);

  useEffect(() => {
    fetch(`${apiUrl}/post_types`)
      .then(res => res.json())
      .then(data => setPostTypes(data))
      .catch(() => setPostTypes([]));
  }, [apiUrl]);
  useEffect(() => {
    let alive = true;
    Promise.all([
      fetch(`${apiUrl}/posts/popular`).then(r => r.json()).catch(() => []),
      fetch(`${apiUrl}/labels`).then(r => r.json()).catch(() => [])
    ]).then(([popular, labels]) => {
      if (!alive) return;
      setPopularPosts(Array.isArray(popular) ? popular : []);
      setTags(Array.isArray(labels) ? labels : []);
    }).finally(() => {
      if (alive) setInitialLoading(false);
    });
    return () => { alive = false; };
  }, [apiUrl]);

  useEffect(() => {
    fetch(`${apiUrl}/latest_posts`)
      .then(res => res.json())
      .then(data => setLatestPosts(data))
      .catch(() => setLatestPosts([]));
  }, [apiUrl]);

  // popular labels still fetched separately for the suggestion cloud

  useEffect(() => {
    fetch(`${apiUrl}/popular_labels`)
      .then(res => res.json())
      .then(data => setPopularLabels(data))
      .catch(() => setPopularLabels([]));
  }, [apiUrl]);


  const handleSearch = useCallback(async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // Only search if at least one filter is present
    if (
      !query.trim() &&
      !author.trim() &&
      !rovat.trim() &&
      !tag.trim() &&
      !from.trim() &&
      !to.trim()
    ) {
      setResults([]);
      setNoResult(true);
      return;
    }
    setLoading(true);
    setNoResult(false);


    const params = new URLSearchParams();
    if (query) params.append('q', query);
    if (author) params.append('author', author);
    if (rovat) params.append('post_type', rovat);
    if (tag) params.append('tag', tag);
    if (from) params.append('from', from);
    if (to) params.append('to', to);

    try {
      const res = await fetch(`${apiUrl}/posts/search?${params.toString()}`);
      const data = await res.json();
      setResults(data);
      setNoResult(data.length === 0);

      // Increment label search count if tag is present
      if (tag) {
        fetch(`${apiUrl}/labels/increment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ label: tag })
        });
      }
    } catch {
      setResults([]);
      setNoResult(true);
    }
    setLoading(false);
  }, [query, author, rovat, tag, from, to, apiUrl, setLoading]);

  // After query state updates to the URL qParam, run the auto search once
  useEffect(() => {
    if (pendingAutoSearchRef.current && query === pendingAutoSearchRef.current) {
      handleSearch({ preventDefault: () => {} });
      pendingAutoSearchRef.current = null;
    }
  }, [query, handleSearch]);

  const handleReset = () => {
    setQuery("");
    setAuthor("");
    setRovat("");
    setTag("");
    setFrom("");
    setTo("");
    setResults([]);
  };

  return (
    <>
      <div>
        <DarkModeButton />
        <Navbar />
        <div className="search-page-container">
          <div className="search-row">
            <aside className="search-column">
              <form className="search-form" onSubmit={handleSearch} autoComplete="off">
                <input
                  type="text"
                  placeholder="Keresés..."
                  value={query}
                  onChange={e => setQuery(e.target.value)}
                />
                <select value={rovat} onChange={e => setRovat(e.target.value)}>
                  <option value="">Rovat kiválasztása</option>
                  {postTypes.map(pt => (
                    <option key={pt.id} value={pt.type}>{pt.type.charAt(0).toUpperCase() + pt.type.slice(1)}</option>
                  ))}
                </select>
                <div className="search-author-input">
                  <input
                    type="text"
                    placeholder="Szerző neve..."
                    value={author}
                    ref={authorInputRef}
                    onFocus={()=>setShowAuthorSuggestions(true)}
                    onBlur={()=>setTimeout(()=>setShowAuthorSuggestions(false), 120)}
                    onChange={e => {
                      setAuthor(e.target.value);
                      setShowAuthorSuggestions(true);
                    }}
                  />
                  {showAuthorSuggestions && author.length > 0 && (
                    <ul className="search-autocomplete-list">
                      {authorSuggestions.filter(a => a.toLowerCase().includes(author.toLowerCase())).slice(0,6).map(a => (
                        <li key={a} onMouseDown={() => { setAuthor(a); setShowAuthorSuggestions(false); authorInputRef.current.blur(); }}>{a}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="search-tag-input">
                  <input
                    type="text"
                    placeholder="Címke..."
                    value={tag}
                    ref={tagInputRef}
                    onFocus={()=>setShowTagSuggestions(true)}
                    onBlur={()=>setTimeout(()=>setShowTagSuggestions(false), 120)}
                    onChange={e => {
                      setTag(e.target.value);
                      setShowTagSuggestions(true);
                    }}
                  />
                  {showTagSuggestions && tag.length > 0 && (
                    <ul className="search-autocomplete-list">
                      {tags.filter(t => t.toLowerCase().includes(tag.toLowerCase())).slice(0,6).map(t => (
                        <li key={t} onMouseDown={() => { setTag(t); setShowTagSuggestions(false); tagInputRef.current.blur(); }}>{t}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <label>
                  Dátumtól:
                  <input type="date" value={from} onChange={e => setFrom(e.target.value)} style={{marginLeft: '8px'}} />
                </label>
                <label>
                  Dátumig:
                  <input type="date" value={to} onChange={e => setTo(e.target.value)}style={{marginLeft: '8px'}} />
                </label>
                <div className="search-btn-row">
                  <button type="submit" className="search-btn">Keresés</button>
                  <button type="button" onClick={handleReset} className="search-btn search-btn-reset">Törlés</button>
                </div>
              </form>
            </aside>
            <main className="results-column">
              {loading ? (
                <div className="search-loading"><LoadingWell loading_title="Keresés..." /></div>
              ) : noResult ? (
                <>
                  <div className="search-noresult">A keresett elemre nincs találat, de itt találhatóak a legfrissebb cikkeink:</div>
                  <div className="search-suggest">
                    <div className="search-suggest-title">Legfrissebb cikkek:</div>
                    {initialLoading ? (
                      <div className="search-loading"><LoadingWell /></div>
                    ) : (
                      <ul>
                        {latestPosts.map(post => (
                          <li key={post.id} className="latest-article-item">
                            <a href={`/article/${post.id}`} className="latest-article-link">
                              {post.thumbnail && (
                                <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} className="latest-article-img" />
                              )}
                              <span className="latest-article-title">{post.title}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                    <div className="search-suggest-title">Népszerű címkék:</div>
                    {initialLoading ? (
                      <div className="search-loading"><LoadingWell /></div>
                    ) : (
                      <div className="search-suggest-tags">
                        {popularLabels.map(tag => (
                          <span className="search-suggest-tag" key={tag} onClick={() => { setTimeout(() => { window.scrollTo({top:0,behavior:'smooth'}); }, 0); setQuery(""); setAuthor(""); setRovat(""); setFrom(""); setTo(""); setTag(tag); setTimeout(() => { handleSearch({ preventDefault: () => {} }); }, 10); }}>#{tag}</span>
                        ))}
                      </div>
                    )}
                  <div className="search-feedback">Nem találtad, amit kerestél? <Link to="/contact">Írj nekünk!</Link></div>
                  </div>
                </>
              ) : results.length === 0 ? (
                <>
                  <div className="search-suggest">
                    {initialLoading ? (
                      <div className="search-loading"><LoadingWell /></div>
                    ) : (
                      <>
                        <div className="search-suggest-title">Népszerű cikkek:</div>
                        <ul>
                          {popularPosts.map(post => (
                            <li key={post.id} className="latest-article-item">
                              <a href={`/article/${post.slug}`} className="latest-article-link">
                                {post.thumbnail && (
                                  <img src={`${storageUrl}${post.thumbnail}`} alt={post.title} className="latest-article-img" />
                                )}
                                <span className="latest-article-title">{post.title}</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                        <div className="search-suggest-title">Népszerű címkék:</div>
                        <div className="search-suggest-tags">
                          {popularLabels.map(tag => (
                            <span className="search-suggest-tag" key={tag} onClick={() => {
                              setTimeout(() => { window.scrollTo({top:0,behavior:'smooth'}); }, 0);
                              setTag(tag);
                              setTimeout(() => {
                                document.querySelector('.search-form .search-btn').click();
                              }, 30);
                            }}>{tag}</span>
                          ))}
                        </div>
                      </>
                    )}
                    <div className="search-feedback">Nem találtad, amit kerestél? <Link to="/contact">Írj nekünk!</Link></div>
                  </div>
                </>
              ) : (
                <>
                  <div className="search-result-count">{results.length} találat</div>
                  <div className="search-results-list">
                    {results.map(article => (
                      <Link key={article.id} to={`/article/${article.slug}`} className="search-result-item">
                          <img src={`${storageUrl}${article.thumbnail}` || "/images/article.jpg"} alt={article.title || "Cikk"} className="search-result-img" />
                          <p>{article.title}</p>
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </main>
            
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </>
  );
}
